import React from "react"

interface StatBarsProps {
  base: number
  more: number
  buff: number
  accent: string
  accentTo: string
}

const BARS = [
  { key: "base", label: "Base Power" },
  { key: "more", label: "Followers Power" },
  { key: "buff", label: "Mutuals Power" },
] as const

function calcPercent(value: number, total: number): number {
  if (!total) return 0
  return Math.min(100, Math.max(0, (value / total) * 100))
}

const StatBars: React.FC<StatBarsProps> = ({ base, more, buff, accent, accentTo }) => {
  const sum = base + more + buff

  return (
    <div className="space-y-5">
      {BARS.map((bar) => {
        const value = bar.key === "base" ? base : bar.key === "more" ? more : buff
        const percent = calcPercent(value, sum)
        return (
          <div key={bar.key}>
            <div className="flex justify-between items-baseline mb-2">
              <span className="text-base text-white/70">{bar.label}</span>
              <span className="text-base font-bold tabular-nums" style={{ color: accent }}>
                {percent.toFixed(0)}%
              </span>
            </div>
            <div className="flex items-center gap-3">
              <div className="flex-1 h-3 rounded-full bg-white/10 overflow-hidden">
                <div
                  className="h-full rounded-full"
                  style={{
                    width: `${percent}%`,
                    background: `linear-gradient(to right, ${accent}, ${accentTo})`,
                  }}
                />
              </div>
              <span className="text-base tabular-nums text-white/80 w-20 text-right">
                {value.toLocaleString()}
              </span>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default StatBars
